/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-lines */
import { DSModal, modalTypes } from '@elliemae/ds-legacy-modal';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { useRef, useState } from 'react';
import AceEditor from 'react-ace';
import DSCodeEditorForm from './components/DSCodeEditorForm.js';
// https://github.com/securingsincity/react-ace/issues/1233
// THE FOLLOWING IMPORTS MUST HAPPEN AS LAST IMPORTS OR ACE EDITOR WILL NOT WORK
import 'ace-builds/src-noconflict/mode-javascript.js';
import 'ace-builds/src-noconflict/theme-tomorrow.js';

type DSCodeEditorProps = {
  containerProps?: object;
  value: string;
  onSave?: (value: string, fileName: string, errors: unknown) => void;
  onClose?: (value: string, fileName: string, errors: unknown) => void;
  onReject?: (value: string, fileName: string, errors: unknown) => void;
  onChange?: (value: string, errors: unknown) => void;
  isOpen?: boolean;
  fileName?: string;
  confirmLabel?: string;
  maxLines?: number;
  minLines?: number;
  modalTitle?: string;
  modalType?: 'confirm' | 'alert';
  rejectLabel?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  style?: object;
  useModal?: boolean;
  showHeader?: boolean;
  showSyntaxChecks?: boolean;
};

const DSCodeEditor = ({
  containerProps = {},
  value: defaultValue = '',
  onSave = () => null,
  onClose = () => null,
  onReject = () => null,
  onChange = () => null,
  isOpen = false,
  fileName = '',
  confirmLabel = 'Save',
  maxLines = 20,
  minLines = 20,
  modalTitle = 'Javascript Editor',
  modalType = 'confirm',
  rejectLabel = 'Close',
  size = 'large',
  style = {},
  useModal = true,
  showHeader = true,
  showSyntaxChecks = true,
}: DSCodeEditorProps) => {
  const [{ value, errors }, setState] = useState({
    value: defaultValue,
    errors: [],
  });
  const reactAceComponent = useRef();

  const Comp = (AceEditor as any)?.default ?? AceEditor;
  const editor = (
    <>
      {/* @ts-expect-error - code-editor typescript compliancy is not a priority */}
      {showHeader && <DSCodeEditorForm fileName={fileName} reactAceComponent={reactAceComponent} />}
      <Comp
        ref={reactAceComponent}
        editorProps={{ $blockScrolling: true }}
        maxLines={maxLines}
        minLines={minLines}
        mode="javascript"
        name="ace-code-edior"
        // @ts-expect-error - code-editor typescript compliancy is not a priority
        onChange={(val) => {
          setState({ errors, value: val });
          onChange(val, errors);
        }}
        // @ts-expect-error - code-editor typescript compliancy is not a priority
        onValidate={(annotations) => setState({ value, errors: annotations })}
        theme="tomorrow"
        setOptions={{
          useWorker: showSyntaxChecks,
        }}
        value={value}
      />
    </>
  );
  if (!useModal) return editor;
  return (
    <DSModal
      centered={false}
      confirmLabel={confirmLabel}
      containerProps={containerProps}
      isOpen={isOpen}
      modalTitle={modalTitle}
      modalType={modalType}
      onClose={() => onClose(value, fileName, errors)}
      onConfirm={() => onSave(value, fileName, errors)}
      onReject={() => onReject(value, fileName, errors)}
      rejectLabel={rejectLabel}
      size={size}
      style={style}
    >
      {editor}
    </DSModal>
  );
};

const codeEditorProps = {
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  value: PropTypes.string.description('editors content').isRequired,
  onSave: PropTypes.func.description('function called when the user press save'),
  onClose: PropTypes.func.description('function called when the user closes the modal'),
  onReject: PropTypes.func.description('function called when is rejected'),
  onChange: PropTypes.func.description('function executed when code editor value changes').isRequired,
  isOpen: PropTypes.bool.description('Whether the modal is opened or not').defaultValue(false),
  fileName: PropTypes.string.description('File name to open in the editor'),
  maxLines: PropTypes.number.description('Max lines in the editor content').defaultValue(20),
  minLines: PropTypes.number.description('Min lines in the editor content').defaultValue(20),
  modalTitle: PropTypes.string.description('Modal title').defaultValue('Javascript Editor'),
  confirmLabel: PropTypes.string.description('Customize modal confirm label').defaultValue('Save'),
  rejectLabel: PropTypes.string.description('Customize modal rejection label').defaultValue('Close'),
  modalType: PropTypes.oneOf(modalTypes).description('Modal type').defaultValue('confirm'),
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
    .description('modal size')
    .defaultValue('large'),
  style: PropTypes.object.description('css inline style'),
  useModal: PropTypes.bool.description('whether to use code editor inside modal or not').defaultValue(true),
  showHeader: PropTypes.bool.description('show editors header').defaultValue(true),
  showSyntaxChecks: PropTypes.bool.description('show syntax warnings and checks').defaultValue(true),
};

DSCodeEditor.displayName = 'DSCodeEditor';
const CodeEditorWithSchema = describe(DSCodeEditor);

// @ts-expect-error - code-editor typescript compliancy is not a priority
CodeEditorWithSchema.propTypes = codeEditorProps;

export { CodeEditorWithSchema, DSCodeEditor };
export default DSCodeEditor;
